export default "__VITE_ASSET__BBsmTlnx__"